/**
 * ZipCodeActiveCard.js
 *
 * A card displayed when a ZIP code is entered that belongs to an active CommunityShare community.
 */
import {CheckCircleIcon} from '@heroicons/react/24/solid';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Displays a success message for an active community.
 *
 * @param {object} props - Component props.
 * @param {string} props.city - The city name.
 * @param {string} props.state - The state name.
 * @returns {JSX.Element} The rendered active card.
 */
export default function ZipCodeActiveCard(props) {
  const {city, state} = props;
  return (
    <div className="flex gap-2 items-start bg-green-100 border border-cs-green-500 rounded-2xl px-4 pt-4 pb-5">
      <CheckCircleIcon className="size-5 shrink-0 text-cs-green-500 mt-0.5"/>
      <div className="flex flex-col gap-4">
        <p className="text-base font-semibold leading-snug text-cs-gray-900">
          Great news - CommunityShare is active in {city || 'your area'}{state ? `, ${state}` : ''}
        </p>
        <p className="text-base leading-snug text-cs-gray-900">
          You&apos;re joining a community where educators and partners are already connecting and creating projects
          together.
        </p>
      </div>
    </div>
  );
}

ZipCodeActiveCard.propTypes = {
  city: PropTypes.string,
  state: PropTypes.string,
};
